class Iframe {
    constructor() {
        // Check user agent as fallback
        this.userAgent = navigator.userAgent || navigator.vendor || window.opera;
    }

    init() {
        const iframes = document.querySelectorAll('iframe[class*="js-iframe-"]');

        if (iframes.length > 0) {
            iframes.forEach((iframe) => {
                const iframeUrl = iframe.src;
                let iframeClass= '';
                let iframeWrapperContainer = null;
                let isMobileFullSize = false;
                let isMobileDevice = this.hasMobileDetected();

                iframe.classList.forEach(function(className) {
                    if (className.startsWith('js-iframe-')) {
                        iframeClass = className;
                    }

                    if (className.includes('has-mobile-fullsize')) {
                        isMobileFullSize = true;
                    }
                });

                if (iframeClass.length > 0) {
                    iframeWrapperContainer = document.querySelector('.' + iframeClass + '-wrapper');
                }

                // Listen for messages from the iframe
                window.addEventListener('message', function(event) {
                    if (iframeUrl.includes(event.origin)) {
                        // Check if the message contains height information
                        if (event.data && typeof event.data === 'object' && event.data.height) {
                            // Update for mobile the iframe height
                            if (isMobileFullSize && isMobileDevice) {
                                iframeWrapperContainer.style.height = (event.data.height + 100) + 'px';
                                iframe.style.height = (event.data.height + 100) + 'px';
                            } else if (event.data.event === 'resize') {
                                iframeWrapperContainer.style.height = event.data.height + 'px';
                                iframe.style.height = event.data.height + 'px';
                            }
                        }

                        const isIframeFullyVisible = Iframe.isElementVisible(iframe);

                        if (isIframeFullyVisible) {
                            // Always scroll the iframe into view
                            try {
                                // Use setTimeout to ensure this happens after any DOM updates
                                setTimeout(() => {
                                    // Get the iframe's position
                                    const rect = iframe.getBoundingClientRect();
                                    const scrollTop = window.scrollY || document.documentElement.scrollTop;

                                    // Calculate position with 100px offset
                                    const targetPosition = rect.top + scrollTop - 65;

                                    // Scroll to the calculated position
                                    window.scrollTo({
                                        top: targetPosition,
                                        behavior: 'smooth'
                                    });
                                }, 100);
                            } catch (error) {
                                console.error('Error scrolling iframe:', error);
                            }
                        }
                    }
                });

                if (isMobileDevice) {
                    // Request height update when parent page resizes
                    window.addEventListener('resize', function() {
                        iframe.contentWindow.postMessage('requestHeight', '*');
                    });

                    // Request height update on orientation change
                    window.addEventListener('orientationchange', function() {
                        // Add a small delay to ensure the orientation change completes
                        setTimeout(function() {
                            iframe.contentWindow.postMessage('requestHeight', '*');
                        }, 100);
                    });
                }
            })
        }
    }

    hasMobileDetected() {
        const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this.userAgent);
        const hasTouchScreen = (
            ('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0)
        );

        return (hasTouchScreen || isMobileUserAgent);
    }

    static isElementVisible(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;

        // Check if any part of the element is in the viewport
        return (
            rect.top < windowHeight &&
            rect.bottom > 0 &&
            rect.left < windowWidth &&
            rect.right > 0
        );
    }
}

export default new Iframe();
